import { render, staticRenderFns } from "./DeviceAlertCreateDialog.vue?vue&type=template&id=632f0952&scoped=true"
import script from "./DeviceAlertCreateDialog.vue?vue&type=script&lang=ts"
export * from "./DeviceAlertCreateDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "632f0952",
  null
  
)

export default component.exports